"use client";

import * as React from "react";

import { cn } from "@beweegbaas/ui/lib/utils";

function Label({ className, ...props }: React.ComponentProps<"label">) {
  return (
    <label
      data-slot="label"
      className={cn(
        `flex items-center gap-2 text-sm leading-none font-medium select-none
        group-data-[disabled=true]:pointer-events-none
        group-data-[disabled=true]:opacity-50
        peer-data-[disabled]:cursor-not-allowed peer-data-[disabled]:opacity-50`,
        className,
      )}
      {...props}
    />
  );
}

export { Label };
